///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { Component, ViewChild, OnInit, AfterViewInit, OnDestroy, Injector } from '@angular/core';

import { State } from '@progress/kendo-data-query';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';

import { DataService } from '../../../core/data/data.service';

import { KbGridComponent } from '../../../shared/components/grid/grid.component';
import { KbDataPanelComponent } from '../../../shared/components/data-panel/data-panel.component';
import { ModelDataResult } from '../../../core/data/model-data-result';

import { ProgressServiceFactory } from '../../../core/data/progress-service-factory';
import { DpTransparentRacuni } from '../../../data/dp-transparent/racuni.model';
import { getRacuniConfig } from '../../../data/dp-transparent/racuni.config';

import { NotificationService } from './../../../core/notification/notification.service';
import { Notification } from './../../../core/notification/notification';

@Component({
    templateUrl: './racuni.view.component.html',
    styleUrls: ['./racuni.view.component.css'],
})
export class RacuniViewBaseComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('grid')
    public $grid: KbGridComponent;
    @ViewChild('dataPanel')
    public $dataPanel: KbDataPanelComponent;

    public $progressServiceFactory: ProgressServiceFactory;
    public $dataServices: { [key: string]: DataService<any> };
    public $dataServicesData: { [key: string]: Observable<any> };
    public $dataServicesResult: { [key: string]: BehaviorSubject<ModelDataResult<any>> };
    public $notificationService: NotificationService;

    public $dataServicesState: { [key: string]: State } = {
        Racuni: {
            skip: 0,
            take: 20,
        },
    };

    public $dataModels: any = {
        RacuniModel: {},
    };

    public $config: any = {
        title: 'Pregled ulaznih računa',
        titleKey: 'modules.Transparentnost.views.Racuni.title',
        newTitle: 'New',
        newTitleKey: 'modules.Transparentnost.views.Racuni.newTitle',
        editTitle: 'Edit',
        editTitleKey: 'modules.Transparentnost.views.Racuni.editTitle',
        editMode: 'Read-Only',
        components: {
            grid: {
                filterable: true,
                groupable: true,
                pageable: this.$dataServicesState['Racuni'].take !== undefined,
                reorderable: true,
                resizable: true,
                sortable: true,
                commandColumnWidth: 220,
                editing: {
                    mode: 'ReadOnly',
                },
                confirmDelete: true,
                events: {
                    onRowSelect: e => {
                        this['onRowSelect'](e);
                    },
                },
            },

            dataPanel: {
                allowEdit: false,
                confirmDelete: true,
                buttonIcons: {
                    back: 'k-icon k-i-undo',
                    cancel: 'k-icon k-i-cancel',
                    create: 'k-icon k-i-add',
                    destroy: 'k-icon k-i-close',
                    edit: 'k-icon k-i-edit',
                    save: 'k-icon k-i-checkmark',
                },
                buttonLabelKeys: {
                    backKey: 'modules.Transparentnost.views.Racuni.editMessages.back',
                    cancelKey: 'modules.Transparentnost.views.Racuni.editMessages.cancel',
                    createKey: 'modules.Transparentnost.views.Racuni.editMessages.create',
                    destroyKey: 'modules.Transparentnost.views.Racuni.editMessages.destroy',
                    editKey: 'modules.Transparentnost.views.Racuni.editMessages.edit',
                    saveKey: 'modules.Transparentnost.views.Racuni.editMessages.save',
                },
            },
            statictext0: {
                textKey: 'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.fields.DatDk',
            },
            text0: {
                format: '',
            },
            label0: {
                forAttribute: 'ctl74',
                textKey: 'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.fields.DatDk',
            },
            ctl74: {
                format: '{0:dd/MM/yyyy}',
                title: 'Datum dokumenta',
                min: new Date('1899-12-31T22:00:00.000Z'),
                max: new Date('2099-12-30T22:00:00.000Z'),
            },
            statictext1: {
                textKey: 'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.fields.BrojUFA',
            },
            text1: {
                format: '',
            },
            label1: {
                forAttribute: 'ctl76',
                textKey: 'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.fields.BrojUFA',
            },
            ctl76: {
                placeholderKey:
                    'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.components.ctl76.placeholder',
                name: 'BrojUFA',
                value: '',
                title: 'Broj računa',
                debounce: 0,
            },
            statictext2: {
                textKey: 'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.fields.NazPar',
            },
            text2: {
                format: '',
            },
            label2: {
                forAttribute: 'ctl80',
                textKey: 'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.fields.NazPar',
            },
            ctl80: {
                placeholderKey:
                    'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.components.ctl80.placeholder',
                name: 'NazPar',
                value: '',
                title: 'Isporučitelj',
                debounce: 0,
            },
            statictext3: {
                textKey: 'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.fields.OIB',
            },
            text3: {
                format: '',
            },
            label3: {
                forAttribute: 'ctl82',
                textKey: 'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.fields.OIB',
            },
            ctl82: {
                placeholderKey:
                    'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.components.ctl82.placeholder',
                name: 'OIB',
                value: '',
                title: 'OIB',
                debounce: 0,
            },
            statictext4: {
                textKey: 'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.fields.OpisDk',
            },
            text4: {
                format: '',
            },
            label4: {
                forAttribute: 'ctl86',
                textKey: 'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.fields.OpisDk',
            },
            ctl86: {
                placeholderKey:
                    'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.components.ctl86.placeholder',
                name: 'OpisDk',
                value: '',
                title: 'Opis dokumenta',
                debounce: 0,
            },
            statictext5: {
                textKey: 'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.fields.Iznos',
            },
            text5: {
                format: '',
            },
            label5: {
                forAttribute: 'ctl90',
                textKey: 'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.fields.Iznos',
            },
            ctl90: {
                placeholderKey:
                    'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.components.ctl90.placeholder',
                downArrowText: '',
                step: 1,
                title: 'Iznos',
                upArrowText: '',
                spinners: false,
            },
            statictext6: {
                textKey: 'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.fields.EvidBroj',
            },
            text6: {
                format: '',
            },
            label6: {
                forAttribute: 'ctl92',
                textKey: 'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.fields.EvidBroj',
            },
            ctl92: {
                placeholderKey:
                    'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.components.ctl92.placeholder',
                name: 'EvidBroj',
                value: '',
                title: 'Evidencijski broj',
                debounce: 0,
            },
            statictext7: {
                textKey: 'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.fields.Valuta',
            },
            text7: {
                format: '',
            },
            label7: {
                forAttribute: 'ctl94',
                textKey: 'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.fields.Valuta',
            },
            ctl94: {
                format: '{0:d}',
                title: 'Dospijeće plaćanja',
                min: new Date('1899-12-31T22:00:00.000Z'),
                max: new Date('2099-12-30T22:00:00.000Z'),
            },
            statictext8: {
                textKey: 'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.fields.Klasa',
            },
            text8: {
                format: '',
            },
            label8: {
                forAttribute: 'ctl96',
                textKey: 'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.fields.Klasa',
            },
            ctl96: {
                placeholderKey:
                    'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.components.ctl96.placeholder',
                name: 'Klasa',
                value: '',
                title: 'Klasa',
                debounce: 0,
            },
            statictext9: {
                textKey: 'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.fields.UrBroj',
            },
            text9: {
                format: '',
            },
            label9: {
                forAttribute: 'ctl98',
                textKey: 'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.fields.UrBroj',
            },
            ctl98: {
                placeholderKey:
                    'modules.Transparentnost.views.Racuni.groups.82d5c650-0fc3-4331-9c58-a9b770a3d153.components.ctl98.placeholder',
                name: 'UrBroj',
                value: '',
                title: 'Urudžbeni broj',
                debounce: 0,
            },
        },
    };

    public $showForm = false;

    constructor(public injector: Injector) {
        this.$progressServiceFactory = this.injector.get(ProgressServiceFactory);
        this.$notificationService = this.injector.get(NotificationService);

        const dsConfig = this.getDataServicesConfig();
        this.$dataServices = {
            Racuni: this.$progressServiceFactory.getService<DpTransparentRacuni>(dsConfig['Racuni'], this.$dataServicesState['Racuni']),
        };

        this.$dataServicesData = {
            Racuni: this.getDataChanges('Racuni'),
        };

        this.$dataServicesResult = {
            Racuni: this.getDataResult('Racuni'),
        };
    }

    public ngOnInit(): void {
        this['onInit']();

        for (const dataSourceName of Object.keys(this.$dataServices)) {
            this.read(dataSourceName);
            this.dataServiceErrors(dataSourceName);
        }

        this.createSelection();
        this.serviceEventsChanges();
    }

    public ngAfterViewInit(): void {
        this['onShow']();
    }

    public ngOnDestroy(): void {
        this['onHide']();
    }

    public onCancel($event) {
        this.resetFormVisibility($event.insertInProcess);
    }

    public onInsert() {
        this.$showForm = true;
    }

    public back(e) {
        this.resetFormVisibility(true);
    }

    public read(dataSourceName): void {
        this.$dataServices[dataSourceName].read();
    }

    public getDataChanges(dataSourceName): Observable<any[]> {
        const dataService = this.$dataServices[dataSourceName];
        return dataService.dataChanges().pipe(map(response => (response ? response.data : [])));
    }

    public getDataResult(dataSourceName): BehaviorSubject<ModelDataResult<any>> {
        return this.$dataServices[dataSourceName].dataChanges();
    }

    public dataServiceErrors(dataSourceName): void {
        this.$dataServices[dataSourceName].errors.subscribe((err: any) => {
            if (err) {
                const message = (err.error && err.error.message) || err.message;
                this.$notificationService.notify(new Notification(`<ul><li>${message}<li></ul>`, 'error', 10000));
            }
        });
    }

    protected getDataServicesConfig() {
        const config = {
            Racuni: getRacuniConfig(),
        };

        return config;
    }

    protected createSelection() {
        this.$grid.kendoGrid.selectionChange.subscribe(e => {
            if (e.selected) {
                this.$dataModels['RacuniModel'] = e.selectedRows[0].dataItem;
            }

            if (this.$config.editMode === 'Edit') {
                this.$dataPanel.onEdit();
            }

            this.$showForm = true;
        });

        this.$grid.kendoGrid.dataStateChange.subscribe(e => {
            this.$grid.selectedKeys = [];
        });
    }

    protected serviceEventsChanges(): void {
        this.$dataServices['Racuni'].events.subscribe(data => {
            this.resetFormVisibility(data.action === 'remove');
        });
    }

    private resetFormVisibility(hideForm: boolean): void {
        this.$showForm = !hideForm && this.$config.editMode === 'Read-Only to Edit';
    }
}



// WEBPACK FOOTER //
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/modules/transparentnost/racuni/racuni.view.base.component.ts